import { defineMessages } from "react-intl";

export const messages = defineMessages({
  validate: {
    id: "modificationPriceManagement.validate",
    defaultMessage: "Validate",
  },
  accommodationPlaceholder: {
    id: "modificationPriceManagement.accommodation.type.placeholder",
    defaultMessage: "Please select a accommodation",
  },
  occupationPlaceholder: {
    id: "modificationPriceManagement.occupation.type.placeholder",
    defaultMessage: "Please select a occupation",
  },
  conditionPlaceholder: {
    id: "modificationPriceManagement.condition.type.placeholder",
    defaultMessage: "Please select a condition",
  },
  mealPlanPlaceholder: {
    id: "modificationPriceManagement.mealPlan.type.placeholder",
    defaultMessage: "Please select a meal plan",
  },
});
